/**
 * Main API service
 * Provides access to all domain-specific API services
 * Network layer: API calls, error wrapping, authentication.
 * No business logic belongs in this layer.
 */
import {
  AuthApiService,
  UserApiService,
  TripApiService,
  HealthApiService,
  LocationApiService,
  MembershipVisitApiService,
  MembershipApiService,
  TravelerApiService,
} from './api/index';

class ApiService {
  // Domain-specific API services
  public auth: AuthApiService;
  public users: UserApiService;
  public trips: TripApiService;
  public health: HealthApiService;
  public locations: LocationApiService;
  public membershipVisits: MembershipVisitApiService;
  public memberships: MembershipApiService;
  public travelers: TravelerApiService;

  constructor() {
    this.auth = new AuthApiService();
    this.users = new UserApiService();
    this.trips = new TripApiService();
    this.health = new HealthApiService();
    this.locations = new LocationApiService();
    this.membershipVisits = new MembershipVisitApiService();
    this.memberships = new MembershipApiService();
    this.travelers = new TravelerApiService();
  }
}

// Create and export singleton instance
export const apiService = new ApiService();
export default apiService;
